import { render } from "./OrderBackTracking.vue?vue&type=template&id=4474c8f9"
import script from "./OrderBackTracking.vue?vue&type=script&lang=js"
export * from "./OrderBackTracking.vue?vue&type=script&lang=js"

import "./OrderBackTracking.vue?vue&type=style&index=0&id=4474c8f9&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__